module.exports = __webpack_public_path__ + "img/lupa.3b250fbb.svg";